import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_app/platform/$")({
  beforeLoad: () => redirect({ to: "/admin", replace: true, throw: true }),
})
